<template>
  <div class="lotti-profile-container">

    <div class="lotti-grid-row lotti-grid-row-small">

      <div class="lotti-grid-col lotti-grid-col-66">

        <div class="lotti-module">
          <div class="lotti-module-title" style="font-size: 30px;">Profil - {{ profileForm.firstname }} {{ profileForm.lastname }}</div>

          <div class="lotti-module-separator-50">

            <el-form :model="profileForm" :rules="profileRules" label-width="130px" ref="profileForm" class="lotti-module-form">

              <div class="lotti-module-group-title">Persönliche Angaben</div>

              <el-form-item label="Vorname" prop="firstname">
                <el-input placeholder="Bitte Vornamen eingeben" v-model="profileForm.firstname"></el-input>
              </el-form-item>

              <el-form-item label="Nachname" prop="lastname">
                <el-input placeholder="Bitte Namen eingeben" v-model="profileForm.lastname"></el-input>
              </el-form-item>

              <el-form-item label="Zugew. Dienst" prop="serviceId">
                <el-select placeholder="Bitte Dienst auswählen" v-model="profileForm.serviceId" :disabled="!auth.user.profile.permissions.is_leader">
                <el-option
                    v-for="item in serviceOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
                </el-select>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" :loading="isLoading.profile" @click="submitProfileData">Profil speichern</el-button>
              </el-form-item>

            </el-form>

            <el-form :model="passwordForm" :rules="passwordRules" label-width="130px" ref="passwordForm" class="lotti-module-form">

              <div class="lotti-module-group-title">Passwort ändern</div>

              <el-form-item label="Passwort" prop="password" autocomplete="off">
                <el-input type="password" placeholder="Passwort" v-model="passwordForm.password"></el-input>
              </el-form-item>

              <el-form-item label="Neues Passwort" prop="passwordNew" autocomplete="off">
                <el-input type="password" placeholder="Neues Passwort" v-model="passwordForm.passwordNew" show-password></el-input>
              </el-form-item>

              <el-form-item label="Neues Passwort" prop="passwordNewConfirm" autocomplete="off">
                <el-input type="password" placeholder="Neues Passwort wiederholen" v-model="passwordForm.passwordNewConfirm" show-password></el-input>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" :loading="isLoading.password" @click="submitPasswordData">Passwort ändern</el-button>
              </el-form-item>

            </el-form>

          </div>

          <div class="lotti-module-separator-50">

            <el-form :model="emailForm" :rules="emailRules" label-width="130px" ref="emailForm" class="lotti-module-form">

              <div class="lotti-module-group-title">E-Mail Adresse ändern</div>

              <el-alert
                  class="lotti-form-alert"
                  title="ACHTUNG"
                  type="warning"
                  :closable="false"
                  description="Ihr Account wird deaktiviert, so lange bis Sie die neue Email Adresse verifiziert haben."
                  show-icon>
              </el-alert>

              <el-form-item label="E-Mail" prop="email">
                <el-input placeholder="Bitte E-Mail eingeben" v-model="emailForm.email"></el-input>
              </el-form-item>

              <el-form-item label="Passwort" prop="password"autocomplete="off">
                <el-input type="password" placeholder="Passwort" v-model="emailForm.password"></el-input>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" :loading="isLoading.email" @click="submitEmailData">E-Mail ändern</el-button>
              </el-form-item>

            </el-form>

            <el-form :model="pensumForm" :rules="pensumRules" label-width="130px" ref="pensumForm" class="lotti-module-form">

              <div class="lotti-module-group-title">Pensum ändern</div>

              <el-alert
                  class="lotti-form-alert"
                  title="ACHTUNG"
                  type="warning"
                  :closable="false"
                  description="Ein neues Pensum überschreibt das aktuelle für alle zukünftigen Zeitberechnungen."
                  show-icon>
              </el-alert>

              <el-form-item label="Wochenlektionen" prop="weeklyLesson">
                <el-input-number
                    style="width: 100%"
                    v-model="pensumForm.weeklyLesson"
                    controls-position="right"
                    :min="0"
                    :max="28"
                    :step="0.1">
                </el-input-number>
              </el-form-item>

              <el-form-item label="Gültig ab" prop="validFrom">
                <el-date-picker
                    style="width: 100%"
                    v-model="pensumForm.validFrom"
                    :picker-options="{ firstDayOfWeek: 1}"
                    type="date"
                    format="dd.MM.yyyy"
                    placeholder="Gültigkeitsdatum">
                </el-date-picker>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" :loading="isLoading.pensum" @click="submitPensumData">Pensum ändern</el-button>
              </el-form-item>

            </el-form>

          </div>

        </div>
      </div>

      <div class="lotti-grid-col lotti-grid-col-33 lotti-grid-mini">
        <div class="lotti-module">
          <div class="lotti-module-title">Arbeitszeit Übersicht</div>

          <table class="lotti-working-time-table">
            <tr>
              <td class="lotti-working-time-title">Überzeit</td>
              <td class="lotti-working-time-data">{{ workingTime.overTime }} min</td>

            </tr>
            <tr>
              <td class="lotti-working-time-title">Pensum</td>
              <td class="lotti-working-time-data">{{ workingTime.pensum }}% </td>
            </tr>
            <tr>
              <td class="lotti-working-time-title">WochenSoll</td>
              <td class="lotti-working-time-data">{{ workingTime.weeklyMinutes }} min</td>

            </tr>
          </table>

        </div>
      </div>

      <div class="lotti-grid-col lotti-grid-col-33 lotti-grid-mini">
        <div class="lotti-module">
          <div class="lotti-module-title">Pensum Historie</div>

          <template>
            <el-table
                :data="pensumHistory"
                stripe
                :default-sort="pensumHistoryDefaultSort"
                height="492px"
                style="width: 100%;">

              <el-table-column
                  prop="date"
                  sortable
                  label="Datum">
                <template slot-scope="scope">
                  {{ datePickerHelper.formatUTCDateCH(scope.row.date) }}
                </template>
              </el-table-column>
              <el-table-column
                  prop="pensum"
                  sortable
                  label="Wochenlektionen">
              </el-table-column>
            </el-table>
          </template>

        </div>
      </div>

    </div>

    <el-dialog
        title="Datenänderung"
        :visible.sync="confirmationDialog"
        center
        modal
        width="400px">
      <div style="text-align: center">Geänderte Daten wirklich speichern?</div>
      <span slot="footer" class="dialog-footer">
          <el-button @click="confirmationDialog = false">Abbrechen</el-button>
          <el-button type="primary" @click="confirmFunction(); confirmationDialog = false">Speichern</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {router} from '../../main.js';
import validation from "../../Helpers/ValidationHelper";
import auth from "../../auth";
import Vue from "../../main";
import datePickerHelper from "../../Helpers/DatePickerHelper";
import notification from "../../Helpers/NotificationHelper";

export default {

  data() {

    let confirmValidate = (rule, value, callback) => {
      if (value !== this.passwordForm.passwordNew) {
        callback(new Error('Das Passwort ist nicht identisch!'));
      } else {
        callback();
      }
    };

    return {
      auth: auth,
      datePickerHelper: datePickerHelper,

      isLoading: {
        email: false,
        profile: false,
        password: false,
        pensum: false,
      },

      pensumHistory: [],
      pensumHistoryDefaultSort:{
          prop: 'date',
          order: 'descending'
      },

      profileForm: {
        firstname: null,
        lastname: null,
        serviceId: null,
      },

      emailForm: {
        email: null,
        password: null,
      },

      passwordForm: {
        password: null,
        passwordNew: null,
        passwordNewConfirm: null,
      },

      pensumForm: {
        weeklyLesson: null,
        validFrom: null,
      },

      workingTime: {
        overTime: null,
        weeklyMinutes: null,
        pensum: null,
      },

      serviceOptions: [],

      confirmationDialog: false,
      confirmFunction: Function,

      profileRules: {
        firstname: [
          validation.getMinMaxValidationObject(2, 45, 'change'),
          validation.getCustomAlphaValidationObject('change'),
          validation.getRequiredValidationObject('change')
        ],
        lastname: [
          validation.getMinMaxValidationObject(2, 45, 'change'),
          validation.getCustomAlphaValidationObject('change'),
          validation.getRequiredValidationObject('change')
        ],
        serviceId: [
          validation.getRequiredValidationObject('change')
        ],
      },

      emailRules: {
        email: [
          validation.getRequiredValidationObject('change'),
          validation.getEmailValidationObject('change'),
        ],
        password: [
          validation.getRequiredValidationObject('change'),
        ]
      },

      passwordRules: {
        password: [
          validation.getRequiredValidationObject('change'),
        ],
        passwordNew: [
          validation.getRequiredValidationObject('change'),
          validation.getContainNumberValidationObject('change'),
          validation.getContainUpperValidationObject('change'),
          validation.getMinLengthValidationObject(8, 'change'),
          validation.getContainLowerValidationObject('change'),
          validation.getContainSymbolValidationObject('change'),
        ],
        passwordNewConfirm: [
          validation.getRequiredValidationObject('change'),
          { validator: confirmValidate, trigger: 'change' }
        ]
      },

      pensumRules: {
        weeklyLesson: [
          validation.getRequiredValidationObject('change'),
        ],
        validFrom: [
          validation.getRequiredValidationObject('change'),
        ],
      },
    }
  },
  methods: {

    submitProfileData() {
      this.confirmFunction = () =>  {
        this.$refs['profileForm'].validate((valid) => {
          if (valid) {

            //start loading indicator
            this.isLoading.profile = true;

            Vue.http.post(
                'api/v1/therapist/update-profile',
                {
                  serviceId: this.profileForm.serviceId,
                  firstname: this.profileForm.firstname,
                  lastname: this.profileForm.lastname,
                }
            ).then(response => {

              //show success msg
              notification.showSuccess(this, 'Daten wurden erfolgreich gespeichert');

              //stop loading indicator
              this.isLoading.profile = false;

            }, error => {
              notification.showError(this, 'Daten konnten nicht gespeichert werden');

              //stop loading indicator
              this.isLoading.profile = false;
            })
          }
        });
      }
      this.confirmationDialog = true;
    },

    submitPasswordData() {
      this.confirmFunction = () =>  {
        this.$refs['passwordForm'].validate((valid) => {
          if (valid) {

            //start loading indicator
            this.isLoading.password = true;

            Vue.http.post(
                'api/v1/therapist/change-password',
                {
                  password: this.passwordForm.password,
                  passwordNew: this.passwordForm.passwordNew,
                }
            ).then(response => {

              //empty password form
              this.$refs['passwordForm'].resetFields();

              //show success msg
              notification.showSuccess(this, 'Daten wurden erfolgreich gespeichert');

              //stop loading indicator
              this.isLoading.password = false;

            }, error => {
              notification.showError(this, 'Daten konnten nicht gespeichert werden');

              //stop loading indicator
              this.isLoading.password = false;
            })
          }
        });
      }
      this.confirmationDialog = true;
    },

    submitEmailData() {
      this.confirmFunction = () =>  {
        this.$refs['emailForm'].validate((valid) => {
          if (valid) {

            //start loading indicator
            this.isLoading.email = true;

            Vue.http.post(
                'api/v1/therapist/change-email',
                {
                  email: this.emailForm.email,
                  password: this.emailForm.password,
                }
            ).then(response => {

              //sign out user
              auth.signout();

              //show success msg
              notification.showSuccess(this, 'Daten wurden erfolgreich gespeichert');

              //stop loading indicator
              this.isLoading.email = false;

            }, error => {
              notification.showError(this, 'Daten konnten nicht gespeichert werden');

              //stop loading indicator
              this.isLoading.email = false;
            })
          }
        });
      }
      this.confirmationDialog = true;
    },

    submitPensumData() {
      this.confirmFunction = () =>  {
        this.$refs['pensumForm'].validate((valid) => {
          if (valid) {

            //start loading indicator
            this.isLoading.pensum = true;

            Vue.http.post(
                'api/v1/therapist/create-pensum',
                {
                  valid_from: datePickerHelper.formatUTCDateTimeUS(this.pensumForm.validFrom),
                  weekly_lessons: this.pensumForm.weeklyLesson,
                }
            ).then(response => {

              //empty date in form
              this.$refs['pensumForm'].resetFields();

              //update pensum history
              this.getPensumHistory();

              //show success msg
              notification.showSuccess(this, 'Daten wurden erfolgreich gespeichert');

              //stop loading indicator
              this.isLoading.pensum = false;

            }, error => {
              notification.showError(this, 'Daten konnten nicht gespeichert werden');

              //stop loading indicator
              this.isLoading.pensum = false;
            })
          }
        });
      }
      this.confirmationDialog = true;
    },

    getMyTherapistData() {
      Vue.http.get(
          'api/v1/therapist/get-my-therapist'
      ).then(response => {

        //profile data
        this.profileForm.firstname = response.data.firstname;
        this.profileForm.lastname = response.data.lastname;
        this.profileForm.serviceId = response.data.service_id;

        //email data
        this.emailForm.email = response.data.email;

        //pensum data
        this.pensumForm.weeklyLesson = response.data.weekly_lesson;

        //worktime data
        this.workingTime.overTime = response.data.over_time;
        this.workingTime.weeklyMinutes = response.data.weekly_minutes;
        this.workingTime.pensum = response.data.pensum;

      }, response => {
        //notification.showError(this, 'Daten konnten nicht geladen werden');
      })
    },

    getPensumHistory() {
      Vue.http.get(
          'api/v1/therapist/get-my-pensum-history'
      ).then(response => {

        //set pensum history data
        this.pensumHistory = response.data;

        //set the current valid pensum in pensumForm as weeklyLessons
        this.pensumForm.weeklyLesson = response.data[0].pensum
      }, response => {
        //notification.showError(this, 'Daten konnten nicht geladen werden');
      })
    },

    getAllServices() {
      Vue.http.get(
          'api/v1/service/get-all'
      ).then(response => {
        this.serviceOptions = response.data.map(item => {
          return { value: item.id, label: item.name };
        });
      }, response => {
        //notification.showError(this, 'Daten konnten nicht geladen werden');
      })
    }
  },

  beforeMount() {

    //get all therapists
    this.getMyTherapistData();

    //get all therapists in selected service
    this.getAllServices();

    //get pensum history
    this.getPensumHistory();
  },
}

</script>